/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AddressCreateRequest,
  AddressCreateRequest$inboundSchema,
  AddressCreateRequest$Outbound,
  AddressCreateRequest$outboundSchema,
} from "./addresscreaterequest.js";

export type ManifestCreateRequestAddressFrom = AddressCreateRequest | string;

export type ManifestCreateRequest = {
  /**
   * ID of carrier account
   */
  carrierAccount: string;
  /**
   * All shipments to be submitted on this day will be closed out.
   *
   * @remarks
   * Must be in the format `2014-01-18T00:35:03.463Z` (ISO 8601 date).
   */
  shipmentDate: string;
  /**
   * IDs transactions to use. If you set this to null or not send this parameter,
   *
   * @remarks
   * Shippo will automatically assign all applicable transactions.
   */
  transactions?: Array<string> | undefined;
  addressFrom: AddressCreateRequest | string;
  async?: boolean | undefined;
};

/** @internal */
export const ManifestCreateRequestAddressFrom$inboundSchema: z.ZodType<
  ManifestCreateRequestAddressFrom,
  z.ZodTypeDef,
  unknown
> = z.union([AddressCreateRequest$inboundSchema, z.string()]);

/** @internal */
export type ManifestCreateRequestAddressFrom$Outbound =
  | AddressCreateRequest$Outbound
  | string;

/** @internal */
export const ManifestCreateRequestAddressFrom$outboundSchema: z.ZodType<
  ManifestCreateRequestAddressFrom$Outbound,
  z.ZodTypeDef,
  ManifestCreateRequestAddressFrom
> = z.union([AddressCreateRequest$outboundSchema, z.string()]);

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ManifestCreateRequestAddressFrom$ {
  /** @deprecated use `ManifestCreateRequestAddressFrom$inboundSchema` instead. */
  export const inboundSchema = ManifestCreateRequestAddressFrom$inboundSchema;
  /** @deprecated use `ManifestCreateRequestAddressFrom$outboundSchema` instead. */
  export const outboundSchema = ManifestCreateRequestAddressFrom$outboundSchema;
  /** @deprecated use `ManifestCreateRequestAddressFrom$Outbound` instead. */
  export type Outbound = ManifestCreateRequestAddressFrom$Outbound;
}

export function manifestCreateRequestAddressFromToJSON(
  manifestCreateRequestAddressFrom: ManifestCreateRequestAddressFrom,
): string {
  return JSON.stringify(
    ManifestCreateRequestAddressFrom$outboundSchema.parse(
      manifestCreateRequestAddressFrom,
    ),
  );
}

export function manifestCreateRequestAddressFromFromJSON(
  jsonString: string,
): SafeParseResult<ManifestCreateRequestAddressFrom, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ManifestCreateRequestAddressFrom$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ManifestCreateRequestAddressFrom' from JSON`,
  );
}

/** @internal */
export const ManifestCreateRequest$inboundSchema: z.ZodType<
  ManifestCreateRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  carrier_account: z.string(),
  shipment_date: z.string(),
  transactions: z.array(z.string()).optional(),
  address_from: z.union([AddressCreateRequest$inboundSchema, z.string()]),
  async: z.boolean().optional(),
}).transform((v) => {
  return remap$(v, {
    "carrier_account": "carrierAccount",
    "shipment_date": "shipmentDate",
    "address_from": "addressFrom",
  });
});

/** @internal */
export type ManifestCreateRequest$Outbound = {
  carrier_account: string;
  shipment_date: string;
  transactions?: Array<string> | undefined;
  address_from: AddressCreateRequest$Outbound | string;
  async?: boolean | undefined;
};

/** @internal */
export const ManifestCreateRequest$outboundSchema: z.ZodType<
  ManifestCreateRequest$Outbound,
  z.ZodTypeDef,
  ManifestCreateRequest
> = z.object({
  carrierAccount: z.string(),
  shipmentDate: z.string(),
  transactions: z.array(z.string()).optional(),
  addressFrom: z.union([AddressCreateRequest$outboundSchema, z.string()]),
  async: z.boolean().optional(),
}).transform((v) => {
  return remap$(v, {
    carrierAccount: "carrier_account",
    shipmentDate: "shipment_date",
    addressFrom: "address_from",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ManifestCreateRequest$ {
  /** @deprecated use `ManifestCreateRequest$inboundSchema` instead. */
  export const inboundSchema = ManifestCreateRequest$inboundSchema;
  /** @deprecated use `ManifestCreateRequest$outboundSchema` instead. */
  export const outboundSchema = ManifestCreateRequest$outboundSchema;
  /** @deprecated use `ManifestCreateRequest$Outbound` instead. */
  export type Outbound = ManifestCreateRequest$Outbound;
}

export function manifestCreateRequestToJSON(
  manifestCreateRequest: ManifestCreateRequest,
): string {
  return JSON.stringify(
    ManifestCreateRequest$outboundSchema.parse(manifestCreateRequest),
  );
}

export function manifestCreateRequestFromJSON(
  jsonString: string,
): SafeParseResult<ManifestCreateRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ManifestCreateRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ManifestCreateRequest' from JSON`,
  );
}
